/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * response of POST prtimes_media_lists/:media_list_id
 * @export
 * @interface UpdateMediaListResponse
 */
export interface UpdateMediaListResponse {
    /**
     * HTTPステータスコード
     * @type {number}
     * @memberof UpdateMediaListResponse
     */
    status?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof UpdateMediaListResponse
     */
    message?: string;
}

export function UpdateMediaListResponseFromJSON(json: any): UpdateMediaListResponse {
    return UpdateMediaListResponseFromJSONTyped(json, false);
}

export function UpdateMediaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMediaListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UpdateMediaListResponseToJSON(value?: UpdateMediaListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

